import React, { forwardRef, ReactNode, useCallback } from 'react';

interface LeftNavContentSectionProps {
    children: ReactNode;
    id: string;
}

export const LeftNavContentSection = forwardRef<
    // Having trouble figuring out how to type the ref here.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any,
    LeftNavContentSectionProps
>((props, ref) => {
    const { children, id } = props;

    const observerCallback = useCallback(
        (target: HTMLElement | null): void => {
            if (typeof ref === 'function' && target !== null) {
                ref(target);
            }
        },
        [ref],
    );

    return (
        <div ref={observerCallback} id={id} className="pt-6">
            {children}
        </div>
    );
});

LeftNavContentSection.displayName = 'LeftNavContentSection';
